import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutAlignLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM8.5 7H7V17H8.5V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignLeft;
